module.exports = __webpack_public_path__ + "img/925cfc0.jpg";